export const meta = {
  id: 'bitonic-sort',
  name: 'Bitonic Sort',
  category: 'Sorting',
  complexity: {
    time: 'O(n log²(n))',
    space: 'O(n log²(n))'
  },
  description: 'Bitonic Sort is a parallel sorting network that sorts bitonic sequences. Suitable for parallel hardware implementations.'
};
